import {
  BUTTON_PAY_ORDER,
  BUTTON_PAY_ANTI,
  BUTTON_PAY_ANTI_ERROR,
  BUTTON_PAY_PAY_SUCCESS,
  BUTTON_PAY_CHECK_ID_SUCCESS,
} from '../constants/buttonpay';

const initState = {
  btnPayOrder: {},
  btnPayAnti: {},
  btnPayAntiErr: {},
  btnPayPaySuc: {},
  btnPayAntiSuc: {},
};

const buttonpay = (state = initState, action = {}) => {
  switch (action.type) {
    case BUTTON_PAY_ORDER:
      return { ...state, btnPayOrder: action.payload };
    case BUTTON_PAY_ANTI:
      return { ...state, btnPayAnti: action.payload };
    case BUTTON_PAY_ANTI_ERROR:
      return { ...state, btnPayAntiErr: action.payload };
    case BUTTON_PAY_PAY_SUCCESS:
      return { ...state, btnPayPaySuc: action.payload };
    case BUTTON_PAY_CHECK_ID_SUCCESS:
      return { ...state, btnPayAntiSuc: action.payload };
    default:
      return state;
  }
};

export default buttonpay;
